import uuid from 'react-uuid';

export const initialReviewQuestionDefinition = {
  required: true, // checked in backend
  grade: "", // the actual question to grade
  score: "", // the score given by the lactor, "" if not graded
  reasoning: "", // the reasoning for the score, "" if not graded
  hasScore: true, // if true, shows a bar beneath the question, its value will be the score
  maxScore: 10, // the max score for the question
  isSelect: false, // if true, shows a select box with the options
  options: null, // the options for the select box, if isSelect is true
  forScore: true  // if true, the question will be included in the final score
};

export const transformDataToFormField = (key, fieldData) => {
  return {
    id: fieldData.id || uuid(), // Ensure each field has a unique ID
    key: key,
    hebrewLabel: fieldData.hebrew_name || '', // Adjust based on actual property names
    type: fieldData.type,
    required: fieldData.require || false,
    order: fieldData.order,
    dependsOn: Array.isArray(fieldData?.dependencies) ? fieldData.dependencies[0].field || '' : '', // Add additional transformations as needed
    condition: Array.isArray(fieldData?.dependencies) ? fieldData.dependencies[0].condition || '' : '', // Add additional transformations as needed
    option: fieldData.option || [], // Adjust based on actual property names
    range: fieldData.range || [], // Adjust based on actual property names
  };
};

export const transformDataToFileFormField = (key, fieldData) => {
  return {
    id: fieldData.id || uuid(), // Ensure each field has a unique ID
    key: key,
    hebrewLabel: fieldData.hebrew_name || '', // Adjust based on actual property names
    required: fieldData.require || false,
    order: fieldData.order,
    max: fieldData.max,
    private: fieldData.private,
    comment: fieldData.comment,
  };
};

export const transformDataToReviewTable = (questionsArrayFromRemoteSource) => {
  return questionsArrayFromRemoteSource.map((question) => {
    return {
      required: question.required ?? initialReviewQuestionDefinition.required,
      grade: question.grade ?? initialReviewQuestionDefinition.grade,
      score: question.score ?? initialReviewQuestionDefinition.score,
      reasoning: question.reasoning ?? initialReviewQuestionDefinition.reasoning,
      hasScore: question.hasScore ?? initialReviewQuestionDefinition.hasScore,
      maxScore: question.maxScore ?? initialReviewQuestionDefinition.maxScore,
      isSelect: question.isSelect ?? initialReviewQuestionDefinition.isSelect,
      options: question.options ?? initialReviewQuestionDefinition.options,
      forScore: question.forScore ?? initialReviewQuestionDefinition.forScore,
    }
  });
}
